import { Component, ElementRef, ViewChild, AfterViewChecked } from '@angular/core';
import { ChatBigWinComponent } from '../chat-big-win/chat-big-win.component';
import { ChatGameEventComponent } from '../chat-game-event/chat-game-event.component';
import { ChatRainComponent } from '../chat-rain/chat-rain.component';
import { ChatSupplyDropComponent } from '../chat-supply-drop/chat-supply-drop.component';
import { ChatSystemMessageComponent } from '../chat-system-message/chat-system-message.component';
import { ChatUserMessageComponent } from '../chat-user-message/chat-user-message.component';
import { ChatService } from '../chat.service';
import { fadeInOut } from '@app/animations';
import { SupplyDropWidgetComponent } from '@features/supply-drop/supply-drop-widget/supply-drop-widget.component';
import { ToggleChatMessageDirective } from '@shared/directives/toggle-chat-message.directive';
import { ToggleUserActionsDirective } from '@shared/directives/toggle-user-actions.directive';
import { SessionService } from '@shared/session.service';
import { UIService } from '@shared/ui.service';

@Component({
  selector: 'app-chat-messages',
  templateUrl: './chat-messages.component.html',
  styleUrls: ['./chat-messages.component.scss'],
  host: {
    '[class.trimmed]': 'isTrimmed()',
  },
  animations: [fadeInOut(200)],
  imports: [
    ChatSystemMessageComponent,
    ChatGameEventComponent,
    ChatBigWinComponent,
    ChatUserMessageComponent,
    ToggleUserActionsDirective,
    ToggleChatMessageDirective,
    ChatRainComponent,
    ChatSupplyDropComponent,
    SupplyDropWidgetComponent,
  ],
})
export class ChatMessagesComponent implements AfterViewChecked {
  @ViewChild('messages') messages: ElementRef;
  disableScrollDown = false;
  lastScrollTop = 0;
  lastMessageTime = 0;
  lastScrollHeight = 0;

  constructor(public chatService: ChatService, public session: SessionService, private uiService: UIService) {}

  ngAfterViewChecked() {
    const element = this.messages.nativeElement;

    if (this.chatService.messages.length < 0) {
      return;
    }

    if (this.chatService.messages.length > 0) {
      const lastMessage = this.chatService.messages[this.chatService.messages.length - 1];
      if (lastMessage.time === this.lastMessageTime) {
        return;
      }

      if (lastMessage.time > this.lastMessageTime && this.disableScrollDown) {
        this.lastMessageTime = lastMessage.time;
      }
    }
    const atBottom = Math.floor(element.scrollHeight - element.scrollTop) < Math.floor(element.clientHeight) + 10;
    if (this.disableScrollDown && atBottom) {
      this.disableScrollDown = false;
      return;
    }

    this.scrollToBottom();
  }

  onScroll() {
    const element = this.messages.nativeElement;
    if (element.scrollHeight !== this.lastScrollHeight) {
      this.lastScrollHeight = element.scrollHeight;
      this.lastScrollTop = element.scrollTop;
      return;
    }

    this.lastScrollHeight = element.scrollHeight;
    if (element.scrollTop < this.lastScrollTop) {
      this.disableScrollDown = true;
      this.lastScrollTop = element.scrollTop;
      return;
    }

    this.lastScrollTop = element.scrollTop;
    const atBottom = Math.floor(element.scrollHeight - element.scrollTop) === Math.floor(element.clientHeight);
    if (this.disableScrollDown && atBottom) {
      this.disableScrollDown = false;
    }
  }

  scrollToBottom(force = false): void {
    if (force) {
      this.disableScrollDown = false;
    }
    if (this.disableScrollDown) {
      return;
    }
    try {
      this.messages.nativeElement.scrollTop = this.messages.nativeElement.scrollHeight;
    } catch {}
  }

  isTrimmed() {
    return this.uiService.uiState().chat === 'trimmed';
  }
}
